import { render, staticRenderFns } from "./SendLink.vue?vue&type=template&id=c3ab074c&scoped=true"
import script from "./SendLink.vue?vue&type=script&lang=js"
export * from "./SendLink.vue?vue&type=script&lang=js"
import style0 from "./SendLink.vue?vue&type=style&index=0&id=c3ab074c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ab074c",
  null
  
)

export default component.exports